import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FadeUp } from "@/components/motion/Reveal";
import { GALLERY_FILTERS, GALLERY_ITEMS } from "@/data/site";

export default function Gallery() {
  const [filter, setFilter] = useState("Tümü");
  const items =
    filter === "Tümü" ? GALLERY_ITEMS : GALLERY_ITEMS.filter((g) => g.category === filter);

  return (
    <section id="galeri" className="bg-ivory py-20 sm:py-28" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-10 lg:flex lg:items-end lg:justify-between gap-8">
          <div>
            <FadeUp>
              <p className="eyebrow text-gold mb-4">Galeri</p>
            </FadeUp>
            <FadeUp delay={0.05}>
              <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-xl">
                Önce & <span className="italic">Sonra</span> Seçkisi
              </h2>
            </FadeUp>
          </div>
          <FadeUp delay={0.1}>
            <p className="mt-4 lg:mt-0 max-w-sm text-espresso/60 text-sm leading-relaxed">
              Görseller yer tutucudur ve gerçek çalışmalarımızla değiştirilecektir.
              Sonuçlar kişiden kişiye değişebilir; görseller, müşterilerimizin izniyle
              paylaşılır.
            </p>
          </FadeUp>
        </div>

        {/* filters */}
        <div className="flex flex-wrap gap-2 mb-10" data-testid="gallery-filters">
          {GALLERY_FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              data-testid={`gallery-filter-${f}`}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-all duration-300 ${
                filter === f
                  ? "bg-espresso text-ivory"
                  : "border border-espresso/20 text-espresso/70 hover:border-espresso/50"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <motion.div layout className="columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          <AnimatePresence>
            {items.map((g, i) => (
              <motion.figure
                layout
                key={`${g.label}-${i}`}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.45, ease: [0.19, 1, 0.22, 1] }}
                className="img-zoom relative mb-5 break-inside-avoid overflow-hidden rounded-2xl bg-espresso"
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.image}
                  alt={`${g.label} — Hülya Suna Beauty`}
                  loading="lazy"
                  className={`w-full object-cover ${i % 3 === 0 ? "aspect-[3/4]" : "aspect-square"}`}
                />
                <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-espresso/80 to-transparent p-4 text-ivory">
                  <span className="eyebrow text-gold text-[10px]">{g.category}</span>
                  <p className="font-serif text-lg leading-tight">{g.label}</p>
                </figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
